import Axios from 'axios';
import { adalApiFetch } from '../../adalConfig';
import { FtpRequestSiteRecord } from '../../types/third-party-publishing/ftp-request-site-record';

const BASE_URL = 'api/thirdpartypublishing';

export const getPublishedSites = (listingId: number): Promise<FtpRequestSiteRecord[]> => {
    return adalApiFetch(Axios.get, `${BASE_URL}/listing/${listingId}/published-sites`)
        .then((response: any) => response.data as FtpRequestSiteRecord[]);
};

export const downloadBlob = (requestId: string): Promise<{ blob: Blob; fileName: string }> => {
    return adalApiFetch(Axios, `${BASE_URL}/${requestId}/download`, {
        method: 'get',
        responseType: 'blob',
    }).then((response: any) => {
        const disposition: string = response.headers['content-disposition'] || '';
        const match = disposition.match(/filename[^;=\n]*=(?:(['"])([^'"\n]*)\1|([^;\n]*))/i);
        const fileName = (match && (match[2] || match[3]) ? (match[2] || match[3]) : 'download').trim();
        return { blob: response.data as Blob, fileName };
    });
};
